import * as yup from 'yup';

export const AvailabilitySchema = yup.object().shape({
    orderType: yup.string().required('Proszę wybrać na kogo ma być zamówienie.'),
});
